import UnderConstruction from "@/components/common/UnderConstruction";

const ManageSecretKeysPage = () => {
  return (
    <div>
      <UnderConstruction />
    </div>
  );
};

export default ManageSecretKeysPage;
